// components/consultation

import getParameter from "../../util/getParameter";
import Consultation from "./reports";

export default Consultation;



// WEBPACK FOOTER //
// ./js/components/consultation/index.js